<template>
  <i style="display: none !important;"/>
</template>

<script>
import layer from '../../mixins/layer';

import _has from "lodash/has";

import {loadModules} from 'esri-loader';

export default {
  mixins: [layer],
  methods: {
    /**
     * @Override
     */
    async loadEsriModules () {
      return await loadModules(['esri/layers/WMTSLayer']);
    },
    /**
     * @returns {Promise<WMTSLayer>}
     * @Override
     */
    async createEsriObject () {
      const [WMTSLayer] = this.$esriModules;
      const layer = new WMTSLayer({
        ...this.properties,
        visible: this.visible
      });
      if (_has(this.properties, 'visible') && this.properties.visible !== this.visible) {
        this.$nextTick(() => {
          this.setVisible(this.properties.visible);
        });
      }

      return layer;
    }
  }
};
</script>
